import { ComponentProps } from 'react';
// eslint-disable-next-line no-restricted-imports -- this is the wrapper R9 points everyone else to
import { Trans as I18nextTrans } from 'react-i18next';

import { useTranslation } from 'src/hooks/use-translation';

type Props = ComponentProps<typeof I18nextTrans>;

/**
 * `<Trans>` from react-i18next that reads the platform edition's wording, like
 * `useTranslation` from `src/hooks/use-translation`. A `t` passed by the caller wins.
 */
export function Trans(props: Props) {
  const { t } = useTranslation(props.ns as Parameters<typeof useTranslation>[0]);

  return <I18nextTrans t={t} {...props} />;
}
